// Pull to refresh — when a touch may start it. A downward drag at the top of
// the page reloads it (components/PullToRefresh.jsx). That is for the page
// itself, never for a surface that takes its own touches: a whiteboard, a
// canvas, a drag handle. A hand resting on a whiteboard and moving down the
// sheet as it writes reloaded the page mid-sketch (2026-10-21, a Surface, in
// the work item and in full screen).
//
// A surface says it takes its own touches with CSS touch-action (none, or
// anything that leaves out vertical panning — the browser does not scroll it
// either) or with the attribute data-no-pull-refresh; a touch that starts on
// it, or inside it, never pulls. Nor does a touch on something laid over the
// page outside the page's own tree (a full-screen view portaled to <body>,
// which React still bubbles to the page), a second finger, or any touch while
// the browser is in full screen.
//
// No React and no document in here — the decision is pure so the suite can
// check it (app-shell/test/run-pull-to-refresh-tests.mjs).

export const NO_PULL_ATTR = 'data-no-pull-refresh';

// A touch-action that still lets the page pan up and down.
export function allowsVerticalPan(touchAction) {
  const ta = String(touchAction || 'auto').trim();
  return ta === 'auto' || ta === 'manipulation' || /\bpan-(y|up|down)\b/.test(ta);
}

// target: the element the touch started on; container: the page's own root
// (the pull-to-refresh wrapper); touches: fingers on the screen; fullscreen:
// document.fullscreenElement is set; touchActionOf(el): its computed
// touch-action.
export function pullMayStart({ target, container, touches = 1, fullscreen = false, touchActionOf = null }) {
  if (fullscreen || touches !== 1 || !target || !container) return false;
  if (typeof container.contains === 'function' && !container.contains(target)) return false;
  for (let el = target; el && el !== container; el = el.parentElement) {
    if (typeof el.hasAttribute === 'function' && el.hasAttribute(NO_PULL_ATTR)) return false;
    if (touchActionOf && !allowsVerticalPan(touchActionOf(el))) return false;
  }
  return true;
}
